//* Am2 Ajax Functions
window.Am2AjaxFunctions = window.Am2AjaxFunctions || {};

window.Am2AjaxFunctions.am2_search_careers = function(){
  jQuery(".search-careers").on('keyup',function(e){
    if( jQuery(this).val().length < 3 ) return;
    e.preventDefault();
      jQuery.ajax({
        // eslint-disable-next-line no-undef
        url : am2_ajax.ajax_url,
        type : 'post',
        data : {
          action : 'am2_search_careers',
          // eslint-disable-next-line no-undef
          nonce : am2_ajax.am2_nonce,
          keyword : jQuery(this).val(),
        },
        // eslint-disable-next-line no-unused-vars
        success : function( data ) {
          data = jQuery.parseJSON(data);
          if(data.success==true){
            jQuery('#careers-results').html(data.html);
          }
        },
    });
  });
}

window.Am2AjaxFunctions.am2_add_to_shortlist = function(){
  jQuery(".add-to-shortlist").on('click',function(e){
    e.preventDefault();
      jQuery.ajax({
        // eslint-disable-next-line no-undef
        url : am2_ajax.ajax_url,
        type : 'post',
        data : {
          action : 'am2_add_to_shortlist',
          // eslint-disable-next-line no-undef
          nonce : am2_ajax.am2_nonce,
          course_id : jQuery(this).data('course-id'),
        },
        // eslint-disable-next-line no-unused-vars
        success : function( data ) {
          data = jQuery.parseJSON(data);
          if(data.success==true){
            window.Am2AjaxFunctions.am2_get_shortlist_box();
            if(!jQuery('.short-list-box').hasClass('opened')){
              jQuery('.short-list-box').toggleClass('opened');
              jQuery('.short-list-box').find('.short-list-dropdown').fadeToggle(300);
              jQuery('.add-to-shortlist').addClass('added-to-shortlist');
              jQuery('.add-to-shortlist').text('');
            }
          }else{
            jQuery('#warning-modal').modal('show').find('.alert--content').html(data.message);
            jQuery('.add-to-shortlist').removeClass('add-to-shortlist').addClass('added-to-shortlist');
          }
        },
    });
  });
}

window.Am2AjaxFunctions.am2_remove_from_shortlist = function(){
  jQuery("body").on('click', '.remove-from-shortlist' ,function(e){
    // eslint-disable-next-line no-console

    e.preventDefault();
      var course_id = jQuery(this).data('course-id');
      jQuery.ajax({
        // eslint-disable-next-line no-undef
        url : am2_ajax.ajax_url,
        type : 'post',
        data : {
          action : 'am2_remove_from_shortlist',
          // eslint-disable-next-line no-undef
          nonce : am2_ajax.am2_nonce,
          course_id : jQuery(this).data('course-id'),
        },
        // eslint-disable-next-line no-unused-vars
        success : function( data ) {
          data = jQuery.parseJSON(data);
          if(data.success==true){
            window.Am2AjaxFunctions.am2_get_shortlist_box();
            window.Am2AjaxFunctions.am2_get_shortlist_checkbox();
            jQuery("#shortlist-bc-course-id-"+course_id).remove();
          }else{
            alert(data.message);
          }
        },
    });
  });
}

window.Am2AjaxFunctions.am2_get_shortlist_box = function(){
  jQuery.ajax({
    // eslint-disable-next-line no-undef
    url : am2_ajax.ajax_url,
    type : 'post',
    data : {
      action : 'am2_get_shortlist_box',
      // eslint-disable-next-line no-undef
      nonce : am2_ajax.am2_nonce,
    },
    // eslint-disable-next-line no-unused-vars
    success : function( data ) {
      data = jQuery.parseJSON(data);
      if(data.success==true){
        jQuery('#shortlist').html(data.html);
      }
    },
  });
}

window.Am2AjaxFunctions.am2_get_shortlist_checkbox = function(){
  jQuery.ajax({
    // eslint-disable-next-line no-undef
    url : am2_ajax.ajax_url,
    type : 'post',
    data : {
      action : 'am2_get_shortlist_checkbox',
      // eslint-disable-next-line no-undef
      nonce : am2_ajax.am2_nonce,
    },
    // eslint-disable-next-line no-unused-vars
    success : function( data ) {
      data = jQuery.parseJSON(data);
      if(data.success==true){
        jQuery('#shortlist-checkbox').html(data.html);
      }
    },
  });
}

window.Am2AjaxFunctions.am2_load_more_courses = function(){
  jQuery("body").on('click', '.load-more-js' ,function(e){

    $(this).attr('disabled', 'disabled');
    e.preventDefault();
    // eslint-disable-next-line no-undef
    var query = jQuery('.load-more-js').data('query');

    if('null' === query) {
      // eslint-disable-next-line no-undef
      query = JSON.parse(am2_ajax.am2_query_vars);
    }

    jQuery.ajax({
      // eslint-disable-next-line no-undef
      url : am2_ajax.ajax_url,
      type : 'post',
      data : {
        action : 'am2_load_more_courses',
        // eslint-disable-next-line no-undef
        nonce : am2_ajax.am2_nonce,
        // eslint-disable-next-line no-undef
        query: query,
        filter: jQuery(this).data('filter'),
        page: jQuery(this).data('page'),
      },
      // eslint-disable-next-line no-unused-vars
      success : function( data ) {
        data = jQuery.parseJSON(data);
        jQuery('.load-more-js').removeAttr('disabled');
        if(data.success==true){
          jQuery('.courses-list').append(data.html).slideDown('slow');
          jQuery('.courses-list .course-box .block').matchHeight();
          jQuery('.courses-list .course-box .block').matchHeight();
          jQuery('.courses-list .course-box .course-features').matchHeight();
          jQuery.fn.matchHeight._update();
          if(data.load_more){
            jQuery('.no-results-text').addClass('hidden');
            jQuery('.load-more-js').removeClass('hidden');
            jQuery('.load-more-js').data('page',data.load_more);
            jQuery('.load-more-js').attr('page',data.load_more);
            jQuery('.load-more-js').data('filter',data.filter);
            jQuery('.load-more-js').attr('filter',data.filter);
            jQuery('.courses-list .course-box .block').matchHeight();
            jQuery.fn.matchHeight._update();
          }else{
            if(!jQuery('.load-more-js').hasClass('hidden')){
              jQuery('.load-more-js').addClass('hidden');
              jQuery('.no-results-text').removeClass('hidden');
            }
          }
        }
      },
    });
    e.stopImmediatePropagation();
    return false;
  });
};

window.Am2AjaxFunctions.am2_load_more_full_time_courses = function(){
  jQuery("body").on('click', '.load-more-full-time-js' ,function(e){
    $(this).attr('disabled', 'disabled');
    e.preventDefault();
    // eslint-disable-next-line no-undef

    jQuery.ajax({
      // eslint-disable-next-line no-undef
      url : am2_ajax.ajax_url,
      type : 'post',
      data : {
        action : 'am2_load_more_full_time_courses',
        // eslint-disable-next-line no-undef
        nonce : am2_ajax.am2_nonce,
        // eslint-disable-next-line no-undef
        page: jQuery(this).data('page'),
        area: jQuery(this).data('area'),
      },
      // eslint-disable-next-line no-unused-vars
      success : function( data ) {
        data = jQuery.parseJSON(data);
        jQuery('.load-more-full-time-js').removeAttr('disabled');
        if(data.success==true){
          jQuery('.load-full-time-courses-list').append(data.html).slideDown('slow');
          jQuery('.load-full-time-courses-list .course-box .block').matchHeight();
          jQuery('.load-full-time-courses-list .course-box .block').matchHeight();
          jQuery('.load-full-time-courses-list .course-box .course-features').matchHeight();
          jQuery.fn.matchHeight._update();
          if(data.load_more){
            jQuery('.load-more-full-time-js').removeClass('hidden');
            jQuery('.load-more-full-time-js').data('page',data.load_more);
            jQuery('.load-more-full-time-js').attr('page',data.load_more);
            jQuery('.load-full-time-courses-list .course-box .block').matchHeight();
            jQuery.fn.matchHeight._update();
          }else{
            if(!jQuery('.load-more-full-time-js').hasClass('hidden')){
              jQuery('.load-more-full-time-js').addClass('hidden');
              jQuery('.load-more-full-time-js').parent().append("<span>There are no more full time courses to display</span>");
            }
          }
        } else {
          if(!jQuery('.load-more-full-time-js').hasClass('hidden')){
            jQuery('.load-more-full-time-js').addClass('hidden');
            jQuery('.load-more-full-time-js').parent().append("<span>There are no more full time courses to display</span>");
          }
        }
      },
    });
    e.stopImmediatePropagation();
    return false;
  });
}

window.Am2AjaxFunctions.am2_load_more_part_time_courses = function(){
  jQuery("body").on('click', '.load-more-part-time-js' ,function(e){
    $(this).attr('disabled', 'disabled');
    e.preventDefault();
    // eslint-disable-next-line no-undef

    jQuery.ajax({
      // eslint-disable-next-line no-undef
      url : am2_ajax.ajax_url,
      type : 'post',
      data : {
        action : 'am2_load_more_part_time_courses',
        // eslint-disable-next-line no-undef
        nonce : am2_ajax.am2_nonce,
        // eslint-disable-next-line no-undef
        page: jQuery(this).data('page'),
        area: jQuery(this).data('area'),
      },
      // eslint-disable-next-line no-unused-vars
      success : function( data ) {
        data = jQuery.parseJSON(data);
        jQuery('.load-more-part-time-js').removeAttr('disabled');
        if(data.success==true){
          jQuery('.load-part-time-courses-list').append(data.html).slideDown('slow');
          jQuery('.load-part-time-courses-list .course-box .block').matchHeight();
          jQuery('.load-part-time-courses-list .course-box .block').matchHeight();
          jQuery('.load-part-time-courses-list .course-box .course-features').matchHeight();
          jQuery.fn.matchHeight._update();
          if(data.load_more){
            jQuery('.load-more-part-time-js').removeClass('hidden');
            jQuery('.load-more-part-time-js').data('page',data.load_more);
            jQuery('.load-more-part-time-js').attr('page',data.load_more);
            jQuery('.load-part-time-courses-list .course-box .block').matchHeight();
            jQuery.fn.matchHeight._update();
          }else{
            if(!jQuery('.load-more-part-time-js').hasClass('hidden')){
              jQuery('.load-more-part-time-js').addClass('hidden');
              jQuery('.load-more-part-time-js').parent().append("<span>There are no more part time courses to display</span>");
            }
          }
        }else{
          if(!jQuery('.load-more-part-time-js').hasClass('hidden')){
            jQuery('.load-more-part-time-js').addClass('hidden');
            jQuery('.load-more-part-time-js').parent().append("<span>There are no more part time courses to display</span>");
          }
        }
      },
    });
    e.stopImmediatePropagation();
    return false;
  });
}

window.Am2AjaxFunctions.am2_load_more_apprenticeship_courses = function(){
  jQuery("body").on('click', '.load-more-apprenticeship-js' ,function(e){
    $(this).attr('disabled', 'disabled');
    e.preventDefault();
    // eslint-disable-next-line no-undef

    jQuery.ajax({
      // eslint-disable-next-line no-undef
      url : am2_ajax.ajax_url,
      type : 'post',
      data : {
        action : 'am2_load_more_apprenticeship_courses',
        // eslint-disable-next-line no-undef
        nonce : am2_ajax.am2_nonce,
        // eslint-disable-next-line no-undef
        page: jQuery(this).data('page'),
        area: jQuery(this).data('area'),
      },
      // eslint-disable-next-line no-unused-vars
      success : function( data ) {
        data = jQuery.parseJSON(data);
        jQuery('.load-more-apprenticeship-js').removeAttr('disabled');
        if(data.success==true){
          jQuery('.load-apprenticeship-courses-list').append(data.html).slideDown('slow');
          jQuery('.load-apprenticeship-courses-list .course-box .block').matchHeight();
          jQuery('.load-apprenticeship-courses-list .course-box .block').matchHeight();
          jQuery('.load-apprenticeship-courses-list .course-box .course-features').matchHeight();
          jQuery.fn.matchHeight._update();
          if(data.load_more){
            jQuery('.load-more-apprenticeship-js').removeClass('hidden');
            jQuery('.load-more-apprenticeship-js').data('page',data.load_more);
            jQuery('.load-more-apprenticeship-js').attr('page',data.load_more);
            jQuery('.load-apprenticeship-courses-list .course-box .block').matchHeight();
            jQuery.fn.matchHeight._update();
          }else{
            if(!jQuery('.load-more-apprenticeship-js').hasClass('hidden')){
              jQuery('.load-more-apprenticeship-js').addClass('hidden');
              jQuery('.load-more-apprenticeship-js').parent().append("<span>There are no more apprenticeship courses to display</span>");
            }
          }
        }else{
          if(!jQuery('.load-more-apprenticeship-js').hasClass('hidden')){
            jQuery('.load-more-apprenticeship-js').addClass('hidden');
            jQuery('.load-more-apprenticeship-js').parent().append("<span>There are no more apprenticeship courses to display</span>");
          }
        }
      },
    });
    e.stopImmediatePropagation();
    return false;
  });
}

window.Am2AjaxFunctions.am2_load_more_university_level_courses = function(){
  jQuery("body").on('click', '.load-more-university-level-js' ,function(e){
    $(this).attr('disabled', 'disabled');
    e.preventDefault();
    // eslint-disable-next-line no-undef

    jQuery.ajax({
      // eslint-disable-next-line no-undef
      url : am2_ajax.ajax_url,
      type : 'post',
      data : {
        action : 'am2_load_more_university_level_courses',
        // eslint-disable-next-line no-undef
        nonce : am2_ajax.am2_nonce,
        // eslint-disable-next-line no-undef
        page: jQuery(this).data('page'),
        area: jQuery(this).data('area'),
      },
      // eslint-disable-next-line no-unused-vars
      success : function( data ) {
        data = jQuery.parseJSON(data);
        jQuery('.load-more-university-level-js').removeAttr('disabled');
        if(data.success==true){
          jQuery('.load-university-level-courses-list').append(data.html).slideDown('slow');
          jQuery('.load-university-level-courses-list .course-box .block').matchHeight();
          jQuery('.load-university-level-courses-list .course-box .block').matchHeight();
          jQuery('.load-university-level-courses-list .course-box .course-features').matchHeight();
          jQuery.fn.matchHeight._update();
          if(data.load_more){
            jQuery('.load-more-university-level-js').removeClass('hidden');
            jQuery('.load-more-university-level-js').data('page',data.load_more);
            jQuery('.load-more-university-level-js').attr('page',data.load_more);
            jQuery('.load-university-level-courses-list .course-box .block').matchHeight();
            jQuery.fn.matchHeight._update();
          }else{
            if(!jQuery('.load-more-university-level-js').hasClass('hidden')){
              jQuery('.load-more-university-level-js').addClass('hidden');
              jQuery('.load-more-university-level-js').parent().append("<span>There are no more university level courses to display</span>");
            }
          }
        }else{
          if(!jQuery('.load-more-university-level-js').hasClass('hidden')){
            jQuery('.load-more-university-level-js').addClass('hidden');
            jQuery('.load-more-university-level-js').parent().append("<span>There are no more university level courses to display</span>");
          }
        }
      },
    });
    e.stopImmediatePropagation();
    return false;
  });
};

window.Am2AjaxFunctions.am2_load_more_distance_learning_courses = function(){
  const $loadMoreDistanceLearningJs = $('.load-more-distance-learning-js');

  $("body").on('click', '.load-more-distance-learning-js' ,function(e){
    $(this).attr('disabled', 'disabled');
    e.preventDefault();
    // eslint-disable-next-line no-undef

    $.ajax({
      // eslint-disable-next-line no-undef
      url : am2_ajax.ajax_url,
      type : 'post',
      data : {
        action : 'am2_load_more_distance_learning_courses',
        // eslint-disable-next-line no-undef
        nonce : am2_ajax.am2_nonce,
        // eslint-disable-next-line no-undef
        page: $(this).data('page'),
        area: $(this).data('area'),
      },
      // eslint-disable-next-line no-unused-vars
      success : function( data ) {
        data = $.parseJSON(data);
        $loadMoreDistanceLearningJs.removeAttr('disabled');
        const $distanceLearningCoursesList = $('.load-distance-learning-courses-list');

        if(data.success==true){
          $distanceLearningCoursesList.append(data.html).slideDown('slow');
          $distanceLearningCoursesList.find('.course-box .block').matchHeight();
          $distanceLearningCoursesList.find('.course-box .course-features').matchHeight();
          $.fn.matchHeight._update();
          if(data.load_more){
            $loadMoreDistanceLearningJs.removeClass('hidden');
            $loadMoreDistanceLearningJs.data('page',data.load_more);
            $loadMoreDistanceLearningJs.attr('page',data.load_more);
            $distanceLearningCoursesList.find('.course-box .block').matchHeight();
            $.fn.matchHeight._update();
          }else{
            if(!$loadMoreDistanceLearningJs.hasClass('hidden')){
              $loadMoreDistanceLearningJs.addClass('hidden');
              $loadMoreDistanceLearningJs.parent().append("<span>There are no more distance learning courses to display</span>");
            }
          }
        }else{
          if(!$loadMoreDistanceLearningJs.hasClass('hidden')){
            $loadMoreDistanceLearningJs.addClass('hidden');
            $loadMoreDistanceLearningJs.parent().append("<span>There are no more distance learning courses to display</span>");
          }
        }
      },
    });
    e.stopImmediatePropagation();
    return false;
  });
};

window.Am2AjaxFunctions.am2_filter_courses_archive = function(){
  jQuery("body").on('click', '.bc-courses-filters' ,function(e){
    e.preventDefault();

    var query = jQuery('.load-more-js').data('query');

    if(!query){
      // eslint-disable-next-line no-undef
      query = am2_ajax.am2_query_vars;
    }

    jQuery.ajax({
      // eslint-disable-next-line no-undef
      url : am2_ajax.ajax_url,
      type : 'post',
      data : {
        action : 'am2_filter_courses_archive',
        // eslint-disable-next-line no-undef
        nonce : am2_ajax.am2_nonce,
        // eslint-disable-next-line no-undef
        query: query,
        filter: jQuery(this).data('bc-filter'),
      },
      // eslint-disable-next-line no-unused-vars
      success : function( data ) {
        data = JSON.parse(data);
        $('.load-courses-list').html(data.html).slideDown('slow');
        $('.results-title').empty().html(data.count_results);
        jQuery('.courses-list .course-box .block').matchHeight();
        jQuery('.courses-list .course-box .course-features').matchHeight();
        jQuery.fn.matchHeight._update();
        if(data.load_more){
          // eslint-disable-next-line no-console
          jQuery('.load-more-js').removeClass('hidden');
          jQuery('.load-more-js').data('page',data.load_more);
          jQuery('.load-more-js').attr('page',data.load_more);
          jQuery('.load-more-js').data('query',data.query);
          jQuery('.load-more-js').attr('query',data.query);
          jQuery('.load-more-js').data('filter',data.filter);
          jQuery('.load-more-js').attr('filter',data.filter);
        }else{
          if(!jQuery('.load-more-js').hasClass('hidden')){
            jQuery('.load-more-js').addClass('hidden');
          }
        }
      },
      error: function(xhr){
          alert(xhr.data);
      },
    });
  });
}

window.Am2AjaxFunctions.am2_search_filters_course_area = function(){
  jQuery('body').on('change','.selectpicker',function(e){
    e.preventDefault();

    var formData = $('.selectpicker').val();

    var query = jQuery('.load-more-js').data('query');

    if(!query){
      // eslint-disable-next-line no-undef
      query = am2_ajax.am2_query_vars;
    }

    jQuery.ajax({
      // eslint-disable-next-line no-undef
      url : am2_ajax.ajax_url,
      type : 'post',
      data : {
        action : 'am2_search_filters_course_area',
        // eslint-disable-next-line no-undef
        nonce : am2_ajax.am2_nonce,
        // eslint-disable-next-line no-undef
        query: query,
        formData : formData,
      },
      // eslint-disable-next-line no-unused-vars
      success : function( data ) {
        data = JSON.parse(data);
        $('.load-courses-list').html(data.html).slideDown('slow');
        $('.results-title').empty().html(data.count_results);
        jQuery('.courses-list .course-box .block').matchHeight();
        jQuery.fn.matchHeight._update();
        if(data.load_more){
          jQuery('.load-more-js').removeClass('hidden');
          jQuery('.load-more-js').data('page',data.load_more);
          jQuery('.load-more-js').attr('page',data.load_more);
          jQuery('.load-more-js').data('query',data.query);
          jQuery('.load-more-js').attr('query',data.query);
        }else{
          if(!jQuery('.load-more-js').hasClass('hidden')){
            jQuery('.load-more-js').addClass('hidden');
          }
        }
      },
      error: function(xhr){
          alert(xhr.data);
      },
    });

  });
}

window.Am2AjaxFunctions.am2_search_filters_courses_archive = function(){

  jQuery('body').on('keyup keypress','.search-courses', function(e) {
  // eslint-disable-next-line no-undef
  var keyCode = e.keyCode || e.which;
  if (keyCode === 13) {
      e.preventDefault();
      document.getElementById("course_search_filters").click();
    }
  });

  jQuery('#button-search-icon-desktop').on('click', function(e) {
    e.preventDefault();
    document.getElementById('course_search_filters').click();
  });

  jQuery("body").on('click', '#course_search_filters' ,function(e){
    e.preventDefault();
    // eslint-disable-next-line no-undef
    var formData = $('.course-search-block form#filters').serializeJSON();
    // eslint-disable-next-line no-undef
    var search = $('.search-courses:visible').val();
    $('#output').html('JSON: ' + formData);
    // eslint-disable-next-line no-undef
    $('.courses-list').slideUp('slow').empty();
    // eslint-disable-next-line no-undef
    var am2_query_vars = JSON.parse(window.am2_ajax.am2_query_vars);
    am2_query_vars.s = search;
    window.am2_ajax.am2_query_vars = JSON.stringify(am2_query_vars);

    jQuery.ajax({
      // eslint-disable-next-line no-undef
      url : am2_ajax.ajax_url,
      type : 'post',
      data : {
        action : 'am2_search_filters_courses_archive',
        // eslint-disable-next-line no-undef
        nonce : am2_ajax.am2_nonce,
        // eslint-disable-next-line no-undef
        s: search,
        // eslint-disable-next-line no-undef
        formData : formData,
      },
      // eslint-disable-next-line no-unused-vars
      success : function( data ) {
        data = JSON.parse(data);
        $('.load-courses-list').html(data.html).slideDown('slow');
        $('.results-title').empty().html(data.count_results);
        jQuery('.no-results-text').addClass('hidden');
        if(data.load_more){
          jQuery('.load-more-js').removeClass('hidden');
          jQuery('.load-more-js').data('page',data.load_more);
          jQuery('.load-more-js').attr('page',data.load_more);
          jQuery('.load-more-js').data('query',data.query);
          jQuery('.load-more-js').attr('query',data.query);
        }else{
          if(!jQuery('.load-more-js').hasClass('hidden')){
            jQuery('.load-more-js').addClass('hidden');
          }
        }
      },
      error: function(xhr){
          alert(xhr.data);
      },
    });
  });

  jQuery("body").on('click', '.search-filters-courses-button-clear' ,function(e){
    e.preventDefault();
    $('input:checkbox').removeAttr('checked');
    // eslint-disable-next-line no-undef
    var formData = $('form#filters').serializeJSON();
    $('#output').html('JSON: ' + formData);
    $('.search_courses_clear').val("");
    // eslint-disable-next-line no-undef
    $('.courses-list').slideUp('slow').empty();
    // eslint-disable-next-line no-undef

    jQuery.ajax({
      // eslint-disable-next-line no-undef
      url : am2_ajax.ajax_url,
      type : 'post',
      data : {
        action : 'am2_search_filters_courses_archive',
        // eslint-disable-next-line no-undef
        nonce : am2_ajax.am2_nonce,
        // eslint-disable-next-line no-undef
        formData : formData,
        // eslint-disable-next-line no-undef
        clear : true,
      },
      // eslint-disable-next-line no-unused-vars
      success : function( data ) {
        data = JSON.parse(data);
        if(data.success==true){
          $('.load-courses-list').html(data.html).slideDown('slow');
          $('.results-title').empty().html(data.count_results);
          jQuery('.no-results-text').addClass('hidden');
          if(data.load_more){
            jQuery('.load-more-js').removeClass('hidden');
            jQuery('.load-more-js').data('page',data.load_more);
            jQuery('.load-more-js').attr('page',data.load_more);
            jQuery('.load-more-js').data('query',data.query);
            jQuery('.load-more-js').attr('query',data.query);
          }else{
            if(!jQuery('.load-more-js').hasClass('hidden')){
              jQuery('.load-more-js').addClass('hidden');
            }
          }
        }
      },
      error: function(xhr){
          alert(xhr.data);
      },
    });
  });

}



// WEBPACK FOOTER //
// ./scripts/partials/am2-ajax.js